import { useId } from 'react';
import Button from './Button';
import Icon from './Icon';

// Tone conveys presentation, never a mapping from database/game status values.
export function StatusBadge({ tone = 'neutral', children, ...props }) {
  return <span {...props} className={`fc-badge fc-tone--${tone}`}>
    {tone !== 'neutral' && <Icon name={tone} />}{children}
  </span>;
}

export function Alert({ tone = 'info', title, children, announce = true }) {
  return <div className={`fc-alert fc-tone--${tone}`}
    role={announce ? (tone === 'danger' ? 'alert' : 'status') : undefined}>
    <Icon name={tone} /><div>{title && <h3 className="fc-label">{title}</h3>}
      {children && <div className="fc-alert__body">{children}</div>}</div>
  </div>;
}

export function LoadingState({ label = 'Loading…' }) {
  return <div className="fc-data-state" role="status">
    <div className="fc-skeleton" aria-hidden="true"><span /><span /><span /></div>
    <p className="fc-helper">{label}</p>
  </div>;
}

export function EmptyState({ title, children, action }) {
  const titleId = useId();
  return <div className="fc-data-state" role="group" aria-labelledby={titleId}>
    <Icon name="empty" /><h3 id={titleId} className="fc-heading-3">{title}</h3>
    {children && <p className="fc-helper">{children}</p>}{action}
  </div>;
}

export function FailedReadState({ title = 'Unable to load', children, onRetry, retrying = false }) {
  const titleId = useId();
  return <div className="fc-data-state" role="group" aria-labelledby={titleId}>
    <Icon name="warning" /><h3 id={titleId} className="fc-heading-3">{title}</h3>
    {children && <p className="fc-helper">{children}</p>}
    {onRetry && <Button variant="secondary" onClick={onRetry} busy={retrying} busyLabel="Retrying…">Try again</Button>}
  </div>;
}
